import { TypeOffre, TypeOffreTarification } from '../../../../hooks';
import { getLangue } from '../../../../utils';
import { ICard } from './CardList';

// Si la card est dans les derniere on enleve le spacer
export const getIsBottomCard = (
    listCards: ICard[],
    currentCard: ICard,
    isTablet: boolean
): boolean => {
    const cardPosition = listCards.findIndex(
        (c) => c.typeOffre === currentCard.typeOffre
    );
    const lastCardPosition = listCards.length - 1;
    const isEvenNumberOfCards: boolean =
        !isTablet && listCards.length % 2 === 0;

    if (isEvenNumberOfCards) {
        if (
            cardPosition === lastCardPosition ||
            cardPosition === lastCardPosition - 1
        ) {
            return true;
        }
    } else {
        if (cardPosition === lastCardPosition) {
            return true;
        }
    }

    return false;
};

export const getNbTagVoisin = (
    listCards: ICard[],
    currentCard: ICard
): number => {
    let nbTagVoisin = 0;

    if (getIsVoisinPromo(listCards, currentCard)) {
        nbTagVoisin++;
    }

    if (getIsVoisinOffreSelectionnee(listCards, currentCard)) {
        nbTagVoisin++;
    }

    return nbTagVoisin;
};

export const getIsVoisinTitreSurDeuxLigne = (
    listCards: ICard[],
    currentCard: ICard,
    isEcranSmall: boolean, // 1200px
    isEcranMedium: boolean // 1440px
): boolean => {
    const voisin = getCardVoisin(listCards, currentCard);
    return getIsTitreSurDeuxLigne(
        voisin?.typeOffre,
        isEcranSmall,
        isEcranMedium
    );
};

export const getIsTitreSurDeuxLigne = (
    typeOffre: string,
    isEcranSmall: boolean, // 1200px
    isEcranMedium: boolean // 1440px
): boolean => {
    const listOffreDeuxLigne: string[] = getListTitreSurDeuxLigne(
        isEcranSmall,
        isEcranMedium
    );

    let isTitreSurDeuxLigne = false;
    listOffreDeuxLigne.forEach((typeOffreSurDeuxLigne) => {
        if (!isTitreSurDeuxLigne && typeOffre === typeOffreSurDeuxLigne) {
            isTitreSurDeuxLigne = true;
        }
    });

    return isTitreSurDeuxLigne;
};

const listOffreTitreDeuxLigneEn: string[] = [
    TypeOffre.CINQ_ANS_VARIABLE_REDUIT,
    TypeOffre.CINQ_ANS_REVISABLE_FERME,
    TypeOffre.CINQ_ANS_VARIABLE_PROTEGE
];

const listOffreTitreDeuxLigneEcranMediumFr: string[] = [
    TypeOffre.CINQ_ANS_REVISABLE_FERME
];

const listOffreTitreDeuxLigneEcranSmallFr: string[] = [
    TypeOffre.CINQ_ANS_REVISABLE_FERME,
    TypeOffre.CINQ_ANS_VARIABLE_PROTEGE
];

const getListTitreSurDeuxLigne = (
    isEcranSmall: boolean, // 1200px
    isEcranMedium: boolean // 1440px
): string[] => {
    const langue = getLangue();
    let listOffreTitreDeuxLigne: string[] = [];

    if (isEcranMedium) {
        if (langue === 'fr') {
            if (isEcranSmall) {
                listOffreTitreDeuxLigne = listOffreTitreDeuxLigneEcranSmallFr;
            } else {
                listOffreTitreDeuxLigne = listOffreTitreDeuxLigneEcranMediumFr;
            }
        } else {
            listOffreTitreDeuxLigne = listOffreTitreDeuxLigneEn;
        }
    }

    return listOffreTitreDeuxLigne;
};

// fonction pour trouver la carte voisin quand non mobile
const getCardVoisin = (listCards: ICard[], currentCard: ICard): any => {
    const cardPosition = listCards.findIndex(
        (c) => c.typeOffre === currentCard.typeOffre
    );
    const cardPositionIsEven = cardPosition % 2 === 0;
    if (cardPositionIsEven) {
        return listCards[cardPosition + 1];
    } else {
        return listCards[cardPosition - 1];
    }
};

const getIsVoisinPromo = (listCards: ICard[], currentCard: ICard): boolean => {
    return (
        getCardVoisin(listCards, currentCard)?.typeOffreTarification ===
        TypeOffreTarification.PROMOTION
    );
};

const getIsVoisinOffreSelectionnee = (
    listCards: any[],
    currentCard: any
): boolean => {
    return getCardVoisin(listCards, currentCard)?.isOffreSelectionnee;
};
